module.exports = __webpack_public_path__ + "img/CCR-3.07223513.png";